import PageContainer from '@/common/components/PageContainer'
import Spinner from '@/common/components/Spinner'
import useQueryGetGameTypeSetting from '@/modules/client-setting/api/hooks/useQueryGetGameTypeSetting'
import GameTypeSettingListing from '@/modules/client-setting/components/GameTypeSetting/components/GameTypeSettingListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function GameTypeSettingPage() {
	const { data: gameTypes, isLoading } = useQueryGetGameTypeSetting()

	if (isLoading || !gameTypes) return <Spinner />

	return (
		<PageContainer>
			<GameTypeSettingListing
				gameTypes={gameTypes?.data || []}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedGameTypeSettingPage = withUserPermission(GameTypeSettingPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.WEB_SETTING],
})

export default GuardedGameTypeSettingPage
